<!--<p>-->
<!--  menu works!-->
<!--</p>-->
<nav>
  @for (item of items; track item) {
    @if (hasAccess(item)) {
      <cm-menu-item
        [item]="item"
        [ngClass]="{ minimized: menuService.isMinimized && isPrimary }"
        [adaptiveSubmenu]="isPrimary"
      ></cm-menu-item>
    }
  }
</nav>
